import DataService from "../../../services/client/classes/dataService";
import { IAddOpportunityOutput } from '../models/interfaces/nonprofitProfile/iAddOpportunityOutput';
import { IAddEditOurMissonOutput } from '../models/interfaces/nonprofitProfile/iAddEditOurMissionOutput';
import { IAddEditAboutUsOutput } from '../models/interfaces/nonprofitProfile/iAddEditAboutUsOutput';
import { IAddEditCausesOutput } from '../models/interfaces/IAddCausesOutput';
import { IAddEditMediaOutput } from '../models/interfaces/nonprofitProfile/iAddEditMediaOutput';
import { ISocialMediaOutput } from '../models/interfaces/iSocialMediaOutput';
import { IAddTextCardOutput } from '../models/interfaces/nonprofitProfile/iAddTextCardOutput';
import { IEditTextCardOutput } from '../models/interfaces/nonprofitProfile/iEditTextCardOutput';
import { IAddEditSocialMediaOutput } from '../models/interfaces/iAddEditSocialMediaOutput';
import { IDeleteTextCardOutput } from '../models/interfaces/nonprofitProfile/iDeleteTextCardOutput';
import { IAddMemberCardOutput } from '../models/interfaces/iAddMemberCardOutput';
import { IApplyForOpportunityOutput } from '../models/interfaces/nonprofitProfile/iApplyForOpportunityOutput';
import { INonprofitFansRequestNewPortionData } from "../models/interfaces/nonprofitProfile/iNonprofitFansRequestNewPortionData";

class NonprofitProfileService extends DataService {
  constructor() {
    super('/private/database/nonprofitProfile/');
  }

  getNonprofitProfileData(orgKey: string): JQuery.jqXHR<any> {
    return this.get('nonprofitProfileData/', { orgKey });
  }

  addOpportunity(opportunity: IAddOpportunityOutput): JQuery.jqXHR<any> {
    return this.post('addOpportunity/', opportunity);
  }

  updateOpportunity(opportunity: IAddOpportunityOutput): JQuery.jqXHR<any> {
    return this.put('updateOpportunity/', opportunity);
  }

  getOpportunityDraft(opportunityKey: string): JQuery.jqXHR<any> {
    return this.get('getOpportunityDraft/', { opportunityKey });
  }

  applyToOpportunity(application: IApplyForOpportunityOutput): JQuery.jqXHR<any> {
    return this.post('applyToOpportunity/', application)
  }

  addEditOurMission(mission: IAddEditOurMissonOutput): JQuery.jqXHR<any> {
    return this.post('addEditOurMission/', mission);
  }

  addEditAboutUs(aboutUs: IAddEditAboutUsOutput): JQuery.jqXHR<any> {
    return this.post('updateCompanyAbout/', aboutUs);
  }

  addCompanyProgram(program: IAddTextCardOutput): JQuery.jqXHR<any> {
    return this.post('addCompanyProgram/', program);
  }

  editCompanyProgram(program: IEditTextCardOutput): JQuery.jqXHR<any> {
    return this.post('editCompanyProgram/', program);
  }

  deleteCompanyCard(card: IDeleteTextCardOutput): JQuery.jqXHR<any> {
    return this.post('deleteCompanyCard/', card);
  }

  addCompanyHistory(history: IAddTextCardOutput): JQuery.jqXHR<any> {
    return this.post('addCompanyHistory/', history);
  }

  editCompanyHistory(history: IEditTextCardOutput): JQuery.jqXHR<any> {
    return this.post('editCompanyHistory/', history);
  }

  changeCauses(data: IAddEditCausesOutput): JQuery.jqXHR<any> {
    return this.post('changeCauses/', data);
  }

  setFavorites(orgKey: string): JQuery.jqXHR<any> {
    return this.post('setFavorites/', { orgKey });
  }

  addEditCompanyMedia(data: IAddEditMediaOutput): JQuery.jqXHR<any> {
    return this.post('addEditCompanyMedia/', data);
  }

  deleteMemberPosition(memberOrgKey: string): JQuery.jqXHR<any> {
    return this.post('deleteMemberPosition/', { memberOrgKey });
  }

  addMemberPosition(member: IAddMemberCardOutput): JQuery.jqXHR<any>{
    return this.post('addMemberPosition/', member);
  }

  deleteOpportunity(key: string): JQuery.jqXHR<any> {
    return this.post('deleteOpportunity/', { key });
  }

  getOpportunityTypeList(template: string = ''): JQuery.jqXHR<any> {
    return this.get('getOpportunityTypeList/', { template });
  }

  getNonprofitFans(data: INonprofitFansRequestNewPortionData): JQuery.jqXHR<any> {
    return this.post('getNonprofitFans/', data);
  }

  getIdentityList(): JQuery.jqXHR<any> {
    return this.get('getIdentityList/');
  }

  getEthnicityList(): JQuery.jqXHR<any> {
    return this.get('getEthnicityList/');
  }

  getSkillsList(): JQuery.jqXHR<any> {
    return this.get('getSkillsList/');
  }

  getSubtypeFunnelList(): JQuery.jqXHR<any> {
    return this.get('getSubtypeFunnelList/');
  }

  getSubtypeFunnelListForSearch(): JQuery.jqXHR<any> {
    return this.get('getSubtypeFunnelListForSearch/');
  }

  getEventTypes(): JQuery.jqXHR<any> {
    return this.get('getEventTypes/')
  }
  getBenefitsList(): JQuery.jqXHR<any> {
    return this.get('getBenefitsList/');
  }

  getResponsobilitiesList(): JQuery.jqXHR<any> {
    return this.get('getResponsobilitiesList/');
  }

  getAllPriorityLevel(): JQuery.jqXHR<any> {
    return this.get('getAllPriorityLevels/');
  }

  updateShortlistedOpportunity(data: IAddOpportunityOutput): JQuery.jqXHR<any> {
    
    return this.post('update_shortlisted_opportunity/', data);
  }

}

export default new NonprofitProfileService();


// WEBPACK FOOTER //
// ./static-content/private/javascripts/services/nonprofitProfileService.ts